import React from 'react';
import closeImg from '../icons/close.svg';
import LangSelect from './LangSelect';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

export default function Sidenav({ opened, setStatus }){
    const { t } = useTranslation();

    if(opened === true){
        document.body.style.overflowY = "hidden";
    }else{
        document.body.style.overflowY = "scroll";
    }
    return(
        <div className={"sidenav " + (opened === true ? "sidenavActive" : '') }>
                <div className="sidenavOverlay"
                    onClick={() => setStatus(false)}
                >
                </div>
                <div className="sidenavContent">
                    <div className="sidenavHeader">
                        <LangSelect dark text="left"/>
                        <img src={closeImg} alt="Aizvērt"
                            onClick={() => setStatus(false)}
                        />
                    </div>
                    <nav>
                        <ul onClick={() => setStatus(false)}>
                            <li>
                                <Link to="/parmums" aria-label="Par mums">{ t('aboutus.title') }</Link>
                            </li>
                            <li>
                                <Link to="/izbraukumi" aria-label="IGGI izbraukumi">{ t('bus.title') }</Link>
                            </li>
                            <li>
                                <Link to="/tirgus" aria-label="IGGI Ābeļdārza tirgus">{ t('garden.title') }</Link>
                            </li>
                            <li>
                                <Link to="/kokteili" aria-label="IGGI kokteiļi">{ t('cocktails.title') }</Link>
                            </li>
                            <li>
                                <Link to="/united" aria-label="IGGI United">{ t('united.title') }</Link>
                            </li>
                            <li>
                                <Link to="/buj" aria-label="BUJ">{ t('faq') }</Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
    )
}
